import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class MatchPassword {
  static passwordMatch(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const current = control.get('currentPassword')?.value;
      const newPwd = control.get('newPassword')?.value;
      const confirm = control.get('confirmPassword')?.value;

      if (!current || !newPwd || !confirm) {
        return null;
      }

      const errors: ValidationErrors = {};

      if (current === newPwd) {
        errors['sameAsCurrent'] = true;
      }
      if (newPwd !== confirm) {
        errors['match'] = true;
      }

      return Object.keys(errors).length ? errors : null;
    };
  }
}
